import Tooltip from '@mui/material/Tooltip';
import dayjs from 'dayjs';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import relativeTime from 'dayjs/plugin/relativeTime';
import React from 'react';

dayjs.extend(relativeTime, LocalizedFormat);

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

// Static post pages are rendered at build time, so the visible date must be
// derived from the ISO string alone — relative formats ("3 days ago") or
// local-timezone Date math differ between server and client and break
// hydration. Client-only contexts (comments) can opt into relative time
// with the `relative` prop. The exact time still appears in the tooltip.
const CreationTime = ({ createdAt, relative }) => {
  const created = createdAt ? dayjs(createdAt) : dayjs();

  let label;
  if (relative) {
    label = created.isBefore(dayjs().startOf('month').add(-1, 'month'))
      ? created.format('MMMM YYYY')
      : created.fromNow();
  } else {
    const match = String(createdAt || '').match(/^(\d{4})-(\d{2})/);
    if (!match) return null;
    label = `${MONTHS[Number(match[2]) - 1]} ${match[1]}`;
  }

  return (
    <Tooltip title={created.format('MMMM DD YYYY H:mm')} placement="bottom">
      <span>{label}</span>
    </Tooltip>
  );
};

export default CreationTime;
